const BASE_URL = 'https://scm.hzyichuan.cn'
// const BASE_URL = 'http://49.235.106.165:8002'
const key = 'bbd0fa901c5d0bbb8a4d59786c022dc9'
const MAP_URL = 'https://restapi.amap.com'
const IMG_URL = 'https://zjjxjunhong.com'
const OSS_PROCESS = '?x-oss-process=video/snapshot,t_0,f_jpg'
const websocket_url = 'wss://scm.hzyichuan.cn/stone-chair-mini/webSocket/'
const socket = new WebSocket(websocket_url);

socket.onopen = function(event) {
    console.log('WebSocket is connected:', event);
    socket.send('Hello Server!');
};

socket.onmessage = function(event) {
    console.log('Message from server:', event.data);
};

socket.onclose = function(event) {
    console.log('WebSocket is closed:', event);
};

socket.onerror = function(error) {
    console.error('WebSocket error: ', error);
};
export { BASE_URL, key, MAP_URL, OSS_PROCESS, IMG_URL, websocket_url }
